import React from 'react';
import { Link } from "react-router-dom";
import { FaArrowRight, FaCalendarAlt, FaUser, FaBookmark } from "react-icons/fa";
import Footer from '../components/common/Footer';

const Blogs = () => {
  const blogPosts = [
    {
      id: 1,
      title: "Agentic AI and the Evolving Role of Leadership: Collaborating with Autonomous Intelligence",
      excerpt: "As artificial intelligence advances from reactive systems to autonomous, agentic AI, we're entering a new era of human-machine collaboration. This transformation is reshaping leadership roles and organizational structures.",
      date: "June 5, 2024",
      author: "Arun Kumar",
      category: "Artificial Intelligence",
      readTime: "8 min read"
    },
    {
      id: 2,
      title: "MLOps at Scale: Engineering the Invisible Backbone of Production AI",
      excerpt: "As machine learning matures from experimentation to real-world deployment, MLOps has become the critical foundation for any organization looking to scale their AI initiatives effectively.",
      date: "May 24, 2024",
      author: "Arun Kumar",
      category: "MLOps",
      readTime: "10 min read"
    },
    {
      id: 3,
      title: "Unlocking the Future of Personalized Healthcare: An AI Revolution",
      excerpt: "Artificial Intelligence (AI) has rapidly transformed industries worldwide, and healthcare is no exception. With the advent of personalized medicine, AI is revolutionizing how we approach patient care and treatment.",
      date: "March 5, 2024",
      author: "Arun Kumar",
      category: "Healthcare AI",
      readTime: "12 min read"
    }
  ];

  return (
    <div className="min-h-screen bg-richblue-5">
      {/* Hero Section */}
      <div className="relative mx-auto flex w-11/12 max-w-maxContent flex-col items-center justify-between gap-8 py-16 text-richblue-700">
        <div className="text-center">
          <h1 className="text-4xl font-bold bg-gradient-to-b from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] text-transparent bg-clip-text font-bold">
            Latest Insights & Articles
          </h1>
          <p className="text-richblue-500 text-lg max-w-3xl mx-auto">
            Explore our collection of expert insights, industry trends, and thought leadership articles
            in technology, AI, and digital transformation.
          </p>
        </div>
      </div>

      {/* Blog Posts Grid */}
      <div className="mx-auto w-11/12 max-w-maxContent py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post) => (
            <div key={post.id} className="bg-richblue-5 rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-richblue-300">
              <div className="p-6">
                <div className="flex items-center justify-between mb-4">
                  <span className="text-sm bg-blue-500/10 text-blue-400 px-3 py-1 rounded-full">
                    {post.category}
                  </span>
                  <span className="text-richblue-500 text-sm flex items-center gap-1">
                    <FaBookmark className="text-blue-400" />
                    {post.readTime}
                  </span>
                </div>
                <h2 className="text-xl font-semibold mb-3 text-richblue-700 hover:text-richblue-600 transition-colors duration-300 line-clamp-2">
                  {post.title}
                </h2>
                <p className="text-richblue-500 mb-4 line-clamp-3">
                  {post.excerpt}
                </p>
                <div className="flex items-center justify-between text-sm text-richblue-500 border-t border-richblue-300 pt-4">
                  <div className="flex items-center gap-2">
                    <FaUser className="text-blue-400" />
                    <span>{post.author}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <FaCalendarAlt className="text-blue-400" />
                    <span>{post.date}</span>
                  </div>
                </div>
                <div className="mt-6">
                  <Link
                    to={`/blog/${post.id}`}
                    className="inline-flex items-center gap-2 text-richblue-600 hover:text-richblue-700 transition-colors duration-300 group"
                  >
                    Read Full Article
                    <FaArrowRight className="text-sm group-hover:translate-x-1 transition-transform duration-300" />
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Newsletter Section */}
      <div className="mx-auto w-11/12 max-w-maxContent py-16">
        <div className="bg-gradient-to-r from-richblue-200/30 to-richblue-100/30 rounded-xl p-8 text-center border border-richblue-200">
          <h2 className="text-2xl font-bold mb-4 text-richblue-700">Stay Updated with Our Insights</h2>
          <p className="text-richblue-500 mb-6">
            Subscribe to our newsletter and be the first to receive our latest articles and industry insights.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <input
              type="email"
              placeholder="Enter your email"
              className="px-4 py-2 rounded-lg bg-richblue-100 text-richblue-900 focus:outline-none focus:ring-2 focus:ring-richblue-400 border border-richblue-300"
            />
            <button className="px-6 py-2 bg-richblue-400 text-white rounded-lg hover:bg-richblue-500 transition-colors duration-300 font-medium">
              Subscribe Now
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Blogs; 